import { useState } from "react";
import { toast } from "sonner";
import { Recycle } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

const TARGETS = ["LinkedIn", "X", "Instagram", "Facebook", "Email"];

export const RepurposeButton = ({ sourceType, sourceId, onDone, label = "Repurpose" }) => {
  const { refresh } = useAuth();
  const [open, setOpen] = useState(false);
  const [sel, setSel] = useState(["LinkedIn", "X", "Instagram"]);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/app/ai/repurpose", { source_type: sourceType, source_id: sourceId, targets: sel });
      toast.success(`${data.items.length} drafts created · ${data.credits_charged} credits (saved ${data.credits_saved})`);
      setOpen(false); refresh(); onDone && onDone();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <button onClick={() => setOpen(true)} data-testid={`repurpose-${sourceId}`} className="inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-semibold hover:bg-foreground/5 text-[#10b981] border-[#10b981]/40"><Recycle className="h-3.5 w-3.5" />{label}</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>Repurpose into channel posts</DialogTitle></DialogHeader>
          <p className="text-sm text-muted-foreground">Reuses this existing content with a low-cost model — 2 credits per channel instead of generating from scratch. Drafts go to Approvals.</p>
          <div className="flex flex-wrap gap-2">{TARGETS.map((t) => (
            <button key={t} onClick={() => setSel(sel.includes(t) ? sel.filter((x) => x !== t) : [...sel, t])} data-testid={`repurpose-target-${t.toLowerCase()}`}
              className={`rounded-full border px-3 py-1.5 text-xs font-medium ${sel.includes(t) ? "bg-[#4f46e5] text-white border-[#4f46e5]" : ""}`}>{t}</button>))}</div>
          <DialogFooter><button disabled={!sel.length || busy} onClick={run} className="btn-brand disabled:opacity-50" data-testid="repurpose-confirm">{busy ? "Repurposing..." : `Create ${sel.length} drafts · ${sel.length * 2} credits`}</button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
